<script>
import useSharedData from "@/use/SharedData.js";
import useTools from "@/use/Tools.js";
import {useSecurityStore} from "@/stores/Security.js"
import {ref, watch} from "vue";
import useSharedMethod from "@/use/SharedMethod.js";
import {useMedicalAppointmentStore} from "@/stores/Medical/MedicalAppointment.js";
import MedicalAppointmentFilter from "@/views/Medical/Appointment/Components/MedicalAppointmentFilter.vue";
import axios from "axios";

export default {
    components: {MedicalAppointmentFilter},
    setup() {
        const {
            loading,
            total,
            filter,
            itemsPerPage
        } = useSharedData();

        const {transformFilterValues, formatedDate, formatedTime} = useSharedMethod();

        const {$router, $i18n} = useTools();

        const medicalAppointmentStore = useMedicalAppointmentStore();
        const securityStore = useSecurityStore();

        const headers = [
            {
                text: "...",
                sortable: false,
                align: "left",
                value: "action",
                width: "0%"
            },
            {
                text: $i18n.t("common.code"),
                align: "left",
                value: "workerCode",
                sortable: true,
                width: "0%"
            },
            {
                text: $i18n.t("module.worker"),
                align: "left",
                value: "workerName",
                sortable: true,
                width: "0%"
            },
            {
                text: $i18n.t("common.date"),
                align: "left",
                value: "date",
                sortable: true,
                width: "0%"
            },
            {
                text: $i18n.t("common.time"),
                align: "left",
                value: "time",
                sortable: true,
                width: "0%"
            },
            {
                text: $i18n.t("common.state"),
                align: "start",
                sortable: true,
                value: "stateName",
                width: "0%"
            },
            {
                text: $i18n.t("common.result"),
                align: "start",
                sortable: true,
                value: "resultName",
                width: "0%"
            },
            {
                text: $i18n.t("common.comment"),
                align: "start",
                sortable: true,
                value: "observation",
            },
        ];

        const actions = [
            {
                title: $i18n.t("module.edms"),
                icon: 'mdi-folder',
                color: 'amber',
                access: () => true,
                disabled: () => false,
                func: (item) => {
                    $router.push({name: 'medical_appointments.documents', params: {id: item.id}})
                },
            },
            {
                title: $i18n.t("module.template_application"),
                icon: 'mdi-text-box-multiple',
                color: 'teal',
                access: () => true,
                disabled: () => false,
                func: (item) => {
                    $router.push({name: 'medical_appointments.template_applications', params: {id: item.id}})
                },
            },
        ];

        const searchParams = ref({
            sortBy: "date",
            descending: true,
            page: 1,
            itemsPerPage: itemsPerPage
        });

        function handleSearch(params) {
            loading.value = true;
            medicalAppointmentStore.setMedicalAppointments([]);
            total.value = 0;


            filter.value.page = params.page - 1;
            filter.value.rowsPerPage = params.itemsPerPage;
            filter.value.sortBy = params.sortBy;
            filter.value.descending = params.descending;

            axios.get('/medicalAppointments', {params: transformFilterValues(filter.value)}).then((response) => {
                medicalAppointmentStore.setMedicalAppointments(response.data.elements);
                total.value = response.data.total;
            }).finally(() => {
                loading.value = false;
            });
        }

        function findAll() {
            handleSearch(searchParams.value);
        }

        watch(() => [filter.value], () => {
            searchParams.page = 1;
            findAll();
        }, {deep: true, immediate: true});

        watch(searchParams, (newParams) => {
            handleSearch(newParams);
        }, {deep: true});



        function clearFilter() {
            Object.keys(filter.value).forEach(key => {
                filter.value[key] = null;
            });
        }

        function view(item) {
            $router.push({name: 'medical_appointments.view', params: {id: item.id}});
        }



        return {
            medicalAppointmentStore,
            securityStore,
            headers,
            loading,
            total,
            filter,
            searchParams,
            actions,
            findAll,
            clearFilter,
            view,
            formatedDate,
            formatedTime,
        };
    },
};
</script>

<template>
    <div>
        <w-app
            :title="$t('module.medical_appointment')"
            show-total
            :total="total"
            show-filter
            :filter="filter"
            @clearFilter="clearFilter"
        >
            <template v-slot:filter>
                <MedicalAppointmentFilter v-model="filter"/>
            </template>

            <template v-slot:rightToolbar>
                <w-btn-reload
                    :loading="loading"
                    @press="findAll"
                />
            </template>

            <template v-slot:content>
                <w-server-data-table
                    v-model="searchParams"
                    :actions="actions"
                    :headers="headers"
                    :items="medicalAppointmentStore.medicalAppointments"
                    :loading="loading"
                    :total="total"
                    root-path="medical_appointments"
                    module="MEDICAL_APPOINTMENT"
                    @rowDbClick="view"
                >
                    <template v-slot:[`item.workerCode`]="{ item }">
                        <w-chip :text="item.workerCode"/>
                    </template>
                    <template v-slot:[`item.workerName`]="{ item }">
                        <w-inline-text bold :text="item.workerName"/>
                    </template>
                    <template v-slot:[`item.date`]="{ item }">
                        <w-inline-text :text="formatedDate(item.date)"/>
                    </template>
                    <template v-slot:[`item.time`]="{ item }">
                        <w-inline-text :text="formatedTime(item.time)"/>
                    </template>
                    <template v-slot:[`item.stateName`]="{ item }">
                        <w-chip color="teal" :text="item.stateName"/>
                    </template>
                    <template v-slot:[`item.resultName`]="{ item }">
                        <w-inline-text :text="item.resultName"/>
                    </template>
                </w-server-data-table>
            </template>
        </w-app>

        <router-view/>
    </div>
</template>
